let BACKEND_SERVER = null;
let BACKEND_DOMAIN = null;
let career_link = null;
if (process.env.REACT_APP_BACKEND_SERVER) {
  BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER;
} else {
  BACKEND_SERVER = "https://dev-api.talchi.ai/api/"
  // BACKEND_SERVER = "https://itconnectus-api.talchi.ai/api/"
  // BACKEND_SERVER = "http://127.0.0.1:8000/api/";

  // BACKEND_DOMAIN = "http://127.0.0.1:8000"
  BACKEND_DOMAIN = "https://dev-api.talchi.ai"
  // BACKEND_DOMAIN = "https://itconnectus-api.talchi.ai"

  // career_link = "https://itconnectus.talchi.ai/careers/"
  career_link = "https://dev.talchi.ai/careers/"
}

const config = {
  basename: '',
  defaultPath: '/dashboard',
  defaultPath1: '/logout',
  fontFamily: "Work Sans, sans-serif",
  borderRadius: 3,
  API_SERVER: BACKEND_SERVER,
  BACKEND_DOMAIN: BACKEND_DOMAIN,
  career_server: career_link,
  TITLE_TXT: 'Talchi ai',
  organization_id: 1,
  ENCRYPT_KEY: "encrypt_item_key",
  LINKEDIN_CLIENT_ID: '86l31756beisu2',
  OTP_VALIDITY: 120,
  PROFILES_PER_PAGE: 24,
  candidate_rejection_reason_list: [
    "No Response", "Budget", "Visa Status", "Notice Period", "Communication", "L0 -Report", "L1-Report", "L2- Report", "HR-Report", "Document Submission", "Background verification", "Others"
  ]
};

export default config;